{
	"selectPeriod": "Selecionar um período",
	"periodSelected": "Período selecionado",
	"reset": "Resetar",
	"apply": "Aplicar",
	"ariaLabels": {
		"periodSelection": "Selecionar um período",
		"periodSelectionOptions": "Opções de seleção de período",
		"periodSelectionDialog": "Seleção de período",
		"dateRangeSelection": "Seleção de intervalo de datas",
		"dateRangeSelectionActions": "Ações de seleção de intervalo de datas",
		"resetDateRange": "Resetar seleção de intervalo de datas",
		"applyDateRange": "Aplicar intervalo de datas selecionado"
	}
}
